import { AppMeta } from "@ops/app/browser";

export const AppMetaInfo = AppMeta();
